import React from "react";
import FlexBox from "components/FlexBox/FlexBox";
import { styled } from "@mui/material/styles";
import { Trans, useTranslation } from "react-i18next";
import { Button, Stack, Typography } from "@mui/material";
import FontIcon, { ODL_ICONS } from "@odl/core/components/DataDisplay/FontIcon";
import InfoLink from "components/InfoLink/InfoLink";
import { WEB_SUPPORT_EMAIL, WEB_SUPPORT_LINK, WEB_SUPPORT_PHONE } from "constants/configs";
import { getHostnameFromUrl } from "utils/getHostnameFromUrl";
import { css } from "@emotion/react";
import MessageSection from "./MessageSection";
import { useHistory } from "react-router";

const SupportSection: React.FC = () => {
  const { t } = useTranslation();
  const webSupportLinkHostname = getHostnameFromUrl(WEB_SUPPORT_LINK);
  const history = useHistory();

  const handleClickBack = React.useCallback(() => {
    history.push("/");
  }, [history]);

  return (
    <FlexBox direction="column" spacing={6} data-testid="SupportSection">
      <StyledMessageSection title={t("Support information")}>
        <Typography variant="body2" textAlign={"center"}>
          {t("Need help? Contact our support team")}
        </Typography>
      </StyledMessageSection>

      <StyledInfoLinkWrapper>
        <InfoLink
          displayValue={WEB_SUPPORT_EMAIL}
          iconName={ODL_ICONS.TECH_EMAIL}
          linkUrl={`mailto:${WEB_SUPPORT_EMAIL}`}
          variant="body2"
        />
        <InfoLink
          displayValue={WEB_SUPPORT_PHONE}
          iconName={ODL_ICONS.TOGGLE_PHONE}
          linkUrl={`tel:${WEB_SUPPORT_PHONE}`}
          variant="body2"
        />
        <InfoLink
          displayValue={webSupportLinkHostname}
          iconName={ODL_ICONS.TRAVEL_EARTH}
          linkUrl={WEB_SUPPORT_LINK}
          variant="body2"
        />
      </StyledInfoLinkWrapper>

      <Typography variant="body2">
        <Trans
          i18nKey="Objective Build applicant support is available <strong>Monday - Friday 8am - 6pm</strong> excl. Public Holidays"
          defaults="Objective Build applicant support is available <strong>Monday - Friday 8am - 6pm</strong> excl. Public Holidays"
          components={{
            strong: <strong />,
          }}
        />
      </Typography>
      <Typography variant="body2">
        {t("Please have your application or consent number to hand before contacting the support team")}
      </Typography>

      <StyledButton
        variant={"text"}
        size={"large"}
        fullWidth={false}
        onClick={handleClickBack}
        startIcon={<FontIcon name={"i-navigation-arrow-left"} />}
      >
        {t(`Back to sign in`)}
      </StyledButton>
    </FlexBox>
  );
};

const StyledMessageSection = styled(MessageSection)(
  ({ theme }) => css`
    margin-top: 8px;
  `
);

const StyledButton = styled(Button)(
  ({ theme }) => css`
    align-self: flex-start;
  `
);

const StyledInfoLinkWrapper = styled(Stack)(
  ({ theme }) => css`
    border-radius: ${theme.spacing(1)};
    padding: ${theme.spacing(4)};
    background: ${theme.palette.grey[300]};
    gap: ${theme.spacing(3)};
  `
);

export default SupportSection;
